import quagganSwimmer from "../images/quaggan_cut_frostsaw.gif";
import anglerFish from "../images/angler.gif";
import dolphin from "../images/dolphin.png";
import dolphinSwimmer from "../images/dolphin_swim.gif";
import manta from "../images/manta.gif";
import magikarp from "../images/magikarp.gif";

// Every swimmer that can appear. Only one of each type can be on screen at a time.
// Optional per-swimmer overrides: duration: { min, max }, top: { min, max }
// min, max are in seconds to cross the entire screen
export const SWIMMERS = [
  {
    type: "quaggan",
    src: quagganSwimmer,
    scale: 1,
    duration: { min: 10, max: 14 },
  },
  {
    type: "angler",
    src: anglerFish,
    scale: 1,
    duration: { min: 10, max: 20 },
  },
  {
    type: "dolphin",
    src: dolphin,
    scale: 2.5,
    duration: { min: 4, max: 5 },
  },
  {
    type: "dolphin2",
    src: dolphinSwimmer,
    scale: 2.5,
    duration: { min: 3, max: 5 },
  },
  {
    type: "manta",
    src: manta,
    scale: 3,
    duration: { min: 6, max: 8 },
  },
  {
    type: "magikarps",
    duration: { min: 14, max: 20 },
    school: {
      sources: [magikarp], // pool of images to pick from
      count: { min: 6, max: 14 }, // fish per school
      fishWidth: { min: 28, max: 50 }, // px, rolled per fish
      spread: { x: 220, y: 110 }, // px, size of the area the school occupies
    },
  },
];

// How often and how likely new swimmers appear
export const SPAWN_CONFIG = {
  firstCheckDelay: 10000, // ms before the first spawn check
  checkDelay: { min: 4000, max: 40000 }, // ms between spawn checks

  // Spawn chance = decay ^ (swimmers currently on screen)
  decay: 0.3,
};

// How each swimmer moves
export const SWIM_CONFIG = {
  baseWidth: 90, // px, width of a swimmer at scale 1
  duration: { min: 12, max: 20 }, // seconds to cross the screen (fallback)
  top: { min: 10, max: 85 }, // vertical position in vh
};
